const Container = ({ children }) => {
  return (
    <div className="bg-[#E8E9EB] p-4 grid md:grid-cols-10 lg:grid-cols-12 xl:grid-cols-8">
      {children}
    </div>
  );
};

export default Container;
